import { render, staticRenderFns } from "./MeScanBodyFigure.vue?vue&type=template&id=5d39015c&scoped=true"
import script from "./MeScanBodyFigure.vue?vue&type=script&lang=js"
export * from "./MeScanBodyFigure.vue?vue&type=script&lang=js"
import style0 from "./MeScanBodyFigure.vue?vue&type=style&index=0&id=5d39015c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d39015c",
  null
  
)

export default component.exports